export const colors = {
  primary: '#5196DF',
  text: '#023060',
  background: '#f5f5f5',
  nav: '#e6e6e6'
};